import { useContext } from 'react'
import { QuickLinks as UDSQuickLinks } from '@telus-uds/components-web'
import { SpacerProps } from '../Spacer/Spacer'
import { getIcon } from '../../../utils/getIcon'
import { renderSpacer } from 'src/siteBuilder/utils/renderSpacer'
import { SiteBuilderContext } from '../../../renderer/context/SiteBuilderContext'
import alloyEvents from '../../../utils/alloyAnalytics/quickLinks'

type itemsProps = {
  text: string
  href: string
  icon: string
}

export type QuickLinksProps = {
  quickLinksItem: itemsProps[]
  spacer?: SpacerProps
}

const QuickLinks = ({ quickLinksItem = [], spacer = undefined }: QuickLinksProps) => {
  const { brand } = useContext(SiteBuilderContext)
  const renderItems = () =>
    quickLinksItem?.map((item) => {
      return (
        <UDSQuickLinks.Item
          key={item.href}
          href={item.href}
          icon={getIcon(item.icon, brand)}
          onClick={() => alloyEvents.click({ item })}
        >
          {item.text}
        </UDSQuickLinks.Item>
      )
    })

  return (
    <div data-testid="quick-links-testid">
      {renderSpacer(spacer)}
      <UDSQuickLinks>{renderItems()}</UDSQuickLinks>
    </div>
  )
}

export default QuickLinks
